//libs\core\auth\src\lib\guards\auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { TenantAuthService } from '../tenant/tenant-auth.service';

export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(TenantAuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  auth.logout();
  return router.createUrlTree(['/login']);
};